import React, { useEffect, useMemo, useState } from 'react'
import { Badge, Button, Col, DropdownItem, DropdownMenu, DropdownToggle, Form, FormGroup, Modal, ModalBody, Row, UncontrolledDropdown } from 'reactstrap'
import { Block, BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Icon, ReactDataTable, RSelect } from '../../../../components/Component'
import { WEBSITE_API_URL } from '../../../../config'
import ToastExample from '../../../../helpers/toast'
import Content from '../../../../layout/content/Content'
import Head from '../../../../layout/head/Head'
import moment from 'moment'
import * as yup from "yup";
import { useDispatch, useSelector } from 'react-redux'
import { collectDeliveryCollection, getAllDeliveryCollection, } from '../../../../redux/admin/report/action'
import { nonActiveFormSubmissionStatus } from '../../../../redux/common/actions'
import DatePicker from "react-datepicker";
import subDays from "date-fns/subDays";
import { Controller, useForm } from 'react-hook-form'
import { string } from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { ColorRing } from 'react-loader-spinner'



const DeliveryCollections = () => {
    const dispatch = useDispatch();

    // get data from redux state
    const getSelectors = (state) => ({
        collections: state.reports.delivery_collections,
    });

    const { collections } = useSelector(getSelectors);


    const [modal, setModal] = useState(false);
    // current delivery collection
    const [currentCollection, setCurrentCollection] = useState([]);

    // message
    const [message, setMessage] = useState("");

    //save selected city id
    const [city_id, setCityId] = useState(null);

    //display error if city not found
    const [error, setError] = useState("");

    // save delivery collection of each user when collection release modal is open
    const [amount, setAmount] = useState(0);
    const [loading, setLoading] = useState(true);
    const [noDate, setNoDate] = useState(false);

    // save date for datepicker
    const [startDate, setStartDate] = useState(subDays(new Date(), 30));
    const [endDate, setEndDate] = useState(new Date());



    // get all delivery collection  onload
    useEffect(() => {
        const city = "All";
        dispatch(getAllDeliveryCollection(city)).then((response) => {
            if (response.payload.success) {
                setLoading(false);
            }
        })
    }, [])

    // delivery collection modal
    const openOrderModal = (collection) => {
        setCurrentCollection(collection)
        dispatch(nonActiveFormSubmissionStatus());
        setTimeout(() => {
            setAmount(collection.amount)
            setModal(true);
        }, 100);
    };

    // on date change
    const handleDatePicker = (dates) => {
        setNoDate(false)
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);
    }

    // filter data according to date picker

    const filterPayout = () => {
        if (startDate && endDate) {
            const formatedStart = moment(startDate).format('DD-MM-yyyy');
            const formatedEnd = moment(endDate).format('DD-MM-yyyy');
            if (city_id) {
                setTimeout(() => {
                    dispatch(getAllDeliveryCollection(city_id, formatedStart, formatedEnd));
                }, 100);
            } else {
                setError("City is Required");
            }
        } else {
            setNoDate(true)
        }
    }

    // export delivery collection report
    const onExport = () => {
        const token = localStorage.getItem('accessToken');
        if (startDate && endDate) {
            const formatedStart = moment(startDate).format('DD-MM-yyyy');
            const formatedEnd = moment(endDate).format('DD-MM-yyyy');
            if (city_id) {
                window.location = WEBSITE_API_URL + "/delivery-collection/export?token=" + token + "&from=" + formatedStart + "&to=" + formatedEnd + "&city=" + city_id;
            } else {
                setError("City is Required");
            }
        } else {
            setNoDate(true)
        }
    }

    // handle message input
    const handleMessage = (message) => {
        setMessage(message);
    };

    const onFormSubmit = (e) => {
        e.preventDefault();
        if (startDate && endDate) {
            const formatedStart = moment(startDate).format('DD-MM-yyyy');
            const formatedEnd = moment(endDate).format('DD-MM-yyyy');
            console.log(currentCollection, formatedStart, formatedEnd, message, city_id, 'dddd')
            dispatch(collectDeliveryCollection(currentCollection?.id, formatedStart, formatedEnd, message, city_id)).then((response) => {
                if (response.payload.success) {
                    setTimeout(() => {
                        dispatch(getAllDeliveryCollection(city_id ? city_id : "All", formatedStart, formatedEnd));
                    }, 100);
                    setModal(false);
                }
            })
        } else {
            setNoDate(true)
        }
    }

    // form validation schema
    const exportSchema = yup.object({

        status: string().required(),
        city_id: string().required(),

    });

    // schema to edit form data
    const defaultValues = useMemo(
        () => ({
            status: "",
            city_id: "",
        }),
        []
    );

    const methods = useForm({
        resolver: yupResolver(exportSchema),
        defaultValues: defaultValues,
    });

    const {
        register,
        handleSubmit,
        watch,
        control,
        formState: { errors },
        unregister,
        reset,
    } = methods;

    //headers of table
    const UserHeading = [
        {
            name: "Name",
            selector: (row) => row?.user?.name,
            sortable: true,
            hide: 370,
        },
        {
            name: "Order Id",
            selector: (row) => row?.order?.unique_order_id ? "#" + row?.order?.unique_order_id : '--',
            sortable: true,
            hide: 370,
        },
        {
            name: "Phone",
            selector: (row) => row?.user?.phone,
            sortable: true,
            hide: 370,
        },
        {
            name: "City",
            selector: (row) => row?.order?.city?.name,
            sortable: true,
            hide: 370,
        },
        {
            name: "Cash On Hand",
            selector: (row) => parseFloat(row.amount).toFixed(2),
            sortable: true,
            hide: "sm",

        },
        {
            name: "Actions",
            compact: true,
            grow: 1,
            style: { paddingRight: "20px" },
            cell: (row) => (
                <div className="user-card mt-2 mb-2">
                    <DropdownTrans row={row} />

                </div>

            ),
            sortable: false,
        },
    ];

    const DropdownTrans = ({ row }) => {
        return (
            <UncontrolledDropdown>
                <DropdownToggle tag="a" className="text-soft dropdown-toggle btn btn-icon btn-trigger">
                    <Icon name="more-h"></Icon>
                </DropdownToggle>
                <DropdownMenu right>
                    <ul className="link-list-plain">
                        <li>
                            <DropdownItem tag="a" onClick={(e) => { openOrderModal(row) }}>
                                <Icon name="download"></Icon>
                                Delivery Collection
                            </DropdownItem>
                        </li>
                        {/* <li>
                            <DropdownItem tag="a" href={'/single-user-delivery-collection-logs/' + row.id}>
                                <Icon name="eye-fill" />

                                View Logs
                            </DropdownItem>
                        </li> */}


                    </ul>
                </DropdownMenu>
            </UncontrolledDropdown>
        );
    };

    const listCity = collections?.cities?.map((city) => (
        { value: city.id, label: city.name }

    ));

    return (
        <React.Fragment>
            {loading ? (
                <Content >
                    <div className='d-flex align-items-center justify-content-center' style={{ minHeight: '75vh' }}>
                        <ColorRing
                            visible={true}
                            height="80"
                            width="80"
                            ariaLabel="blocks-loading"
                            wrapperStyle={{}}
                            wrapperClass="blocks-wrapper"
                            colors={['#fcc314', '#fcc314', '#fcc314', '#fcc314', '#fcc314']}
                        />
                    </div>
                </Content>
            ) :
                <React.Fragment>
                    <Head title="Delivery Collection "></Head>
                    <Content>
                        <BlockHead size="sm">
                            <BlockBetween>
                                <BlockHeadContent>
                                    <BlockTitle tag="h3" page>
                                        Delivery Collection
                                    </BlockTitle>
                                    <BlockDes className="text-soft">
                                        <p>You have total {collections?.count} Delivery Collection .</p>
                                        <span className=''>
                                            Total COD Pending :
                                            <Badge pill color="primary" className='mx-2'>{collections?.codCollectionPendingCount}</Badge>
                                        </span>
                                        <span className='mx-3'>
                                            Total Amount Pending :
                                            <Badge pill color="primary" className='mx-2'> ₹ {parseFloat(collections?.pendingAmount).toFixed(2)}</Badge>
                                        </span>
                                    </BlockDes>
                                </BlockHeadContent>
                            </BlockBetween>
                        </BlockHead>
                        <Block>
                            <Row className='mb-3'>
                                <Col md="4">
                                    <span className="form-label">Choose Date Range</span>
                                    <DatePicker
                                        selected={startDate}
                                        onChange={handleDatePicker}
                                        startDate={startDate}
                                        endDate={endDate}
                                        selectsRange
                                        dateFormat="dd-MM-yyyy"
                                        className="form-control date-picker"
                                        required
                                    />
                                    {noDate && (
                                        <span className="invalid text-danger text-italic">Please Select Date Range </span>
                                    )}
                                </Col>
                                <Col md="4">
                                    <span className="form-label">Select a City</span>
                                    <Controller
                                        name="city_id"
                                        control={control}
                                        render={({ onChange, value, ref }) => (
                                            <RSelect
                                                options={listCity}
                                                onChange={(val) => {
                                                    setCityId(val?.value)
                                                    onChange(val?.value)
                                                }}
                                                defaultValue={listCity?.find((c) => c?.value === city_id)}
                                            />
                                        )}
                                        ref={register({ required: "This field is required" })}
                                    />
                                    {!city_id && (<span className="invalid text-danger text-italic">{error}</span>)}
                                </Col>
                                <Col md="3" className='d-flex align-items-end'>
                                    <Button outline color="success" className='mx-3' onClick={() => { filterPayout() }}>
                                        <span>Filter</span>
                                    </Button>
                                    <Button outline color="primary" className='mx-3' onClick={() => { onExport() }}>
                                        <Icon name="download-cloud"></Icon>
                                        <span>Export</span>
                                    </Button>
                                </Col>
                            </Row>
                        </Block>
                        {/* datatable */}
                        <ReactDataTable
                            data={collections?.codCollections}
                            columns={UserHeading}
                            pagination
                        />
                    </Content>


                    {/* view collection release modal */}
                    <Modal
                        isOpen={modal}
                        toggle={() => setModal(false)}
                        className="modal-dialog-centered"
                        size="lg"
                    >
                        <ModalBody className="pt-3 pb-2">
                            <a
                                href="#cancel"
                                onClick={(ev) => {
                                    ev.preventDefault();
                                    setModal(false)
                                }}
                                className="close"
                            >
                                <Icon name="cross-sm"></Icon>
                            </a>
                            <div className='p-2'>
                                <h5 className="title">Cash on Hand : ₹ {amount}</h5>
                                <Form className=" gy-4" onSubmit={(e) => { onFormSubmit(e) }}>

                                    <Row>
                                        <Col md="8">
                                            <FormGroup>
                                                <label className="form-label">Message</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="message"
                                                    onChange={(e) => {
                                                        e.preventDefault();
                                                        handleMessage(e.target.value);
                                                    }}
                                                    placeholder="Enter Message"

                                                />

                                            </FormGroup>
                                        </Col>
                                        <Col md="4" className='d-flex align-items-end'>

                                            <Button type="submit" color="success" size="lg" className="btn-dim">

                                                Collect

                                            </Button>
                                        </Col>
                                    </Row>

                                </Form>

                            </div>

                        </ModalBody>
                    </Modal>
                </React.Fragment>
            }
        </React.Fragment>
    )
}

export default DeliveryCollections
